import React from "react";
import { usePageSeo, SectionTitle, JsonLd, SITE_URL } from "../components/common";
import { FAQ } from "../content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

export default function Faq() {
  usePageSeo({
    title: "FAQ — tirages intuitifs & cartomancie à distance",
    description: "Réponses aux questions sur les tirages intuitifs à distance, la cartomancie, les séances énergétiques, Entre Lui et Moi et le Guide Tarot de Noëmie.",
    path: "/faq",
  });
  return (
    <div className="home-dark min-h-[80vh]">
      <JsonLd data={{
        "@context": "https://schema.org", "@type": "FAQPage",
        "@id": `${SITE_URL}/faq`,
        mainEntity: FAQ.map((i) => ({
          "@type": "Question", name: i.q,
          acceptedAnswer: { "@type": "Answer", text: i.a },
        })),
      }} />
      <div className="container-x py-12 sm:py-20 fade-up max-w-3xl">
        <SectionTitle eyebrow="Questions fréquentes" title="Tes questions, mes réponses" center />
        <div className="mt-10">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQ.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="card-soft px-5 border-0"
              >
                <AccordionTrigger className="text-left font-serif text-lg text-[#5A3A4B] hover:no-underline">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#7A5D58] leading-relaxed text-sm">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  );
}
